import React, { useEffect, useContext } from "react"
import Sogehts from "../components/home/Sogehts"
import { getText } from "../components/strapi"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { Context } from "../store/store"
import { Link } from "react-router-dom"
import Spinner from "../components/elements/Spinner"
import MobileMenu from "../components/MobileMenu"
const Prescreen: React.FC = () => {
	const { globalState } = useContext(Context)
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			{globalState.strapi.homepage ? (
				<div className="light bg-greenBG">
					<MobileMenu />
					<div className="relative ">
						<img src="/images/hero-bubbles.jpg" alt="" className="absolute  left-[50%] top-[28%] z-10  h-auto w-[52%]" />
						<img src="/images/hero-bubbles.jpg" alt="" className="absolute  left-[40%] top-[28%] z-10  h-auto w-[52%]" />
						<img src="/images/soon.png" alt="" className="relative z-20 w-full hidden md:block" />
						<img src="/images/soon-mobile.png" alt="" className="relative z-20 w-full block md:hidden" />
						<div className="bg-greenBG -mt-20">
							<Sogehts />
						</div>
					</div>
					<div className="rounded-border relative p-6 bg-white">
						<p className="mt-12 mb-12 text-center copy text-[14px] lg:text-[19px] max-w-[540px]">
							{getText(globalState.strapi.homepage.activePeriod, "activePeriod")}{" "}
							<Link to={"/teilnahmebedingungen"} className="underline">
								Teilnahmebedingungen
							</Link>
							.
						</p>
						<div className="grid grid-cols-1 items-center">
							<a
								href="https://www.volvic.de"
								className=" tracking-wide mb-6 block w-[100%] rounded-full bg-[#FFDD08]   text-center md:mx-auto p-4 font-Veener text-[29px]  sm:text-[42px] leading-none font-bold uppercase text-[#007331] sm:w-[auto]  lg:inline-block lg:py-2 lg:px-6"
								style={{
									boxShadow: "0px 2.21px 16.575px 0px rgba(0, 0, 0, 0.40)",
								}}
							>
								zur volvic Website
							</a>
						</div>
					</div>
				</div>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
			<img src="/images/divider.png" alt="" className="-mb-[1px] w-full -scale-x-100 -scale-y-100" />
		</>
	)
}
export default Prescreen
